module.exports = __webpack_public_path__ + "media/recipes/74-2499c158.png";